import { db } from "../firebase";

const collectionRef = db.collection("Sessions");

const getPagesRef = (sessionNumber, modyulNumber) => {
  const ref = collectionRef
    .doc(`session${sessionNumber}`)
    .collection("Modules")
    .doc(`module${modyulNumber}`)
    .collection("Pages");
  return ref;
};

const getAllPagesByModule = async (sessionNumber, modyulNumber) => {
  const output = [];
  const ref = getPagesRef(sessionNumber, modyulNumber);
  const collection = await ref.get();
  if (collection.size) {
    collection.forEach((document) => {
      output.push({ id: document.id, data: document.data() });
    });
  }
  return output;
};

const getSinglePage = async (sessionNumber, modyulNumber, pgNumber) => {
  let data = {};
  const ref = getPagesRef(sessionNumber, modyulNumber).doc(`pg${pgNumber}`);
  const document = await ref.get();

  if (document.exists) {
    data = document.data();
  }

  return data;
};

const sessions = {
  getAllPagesByModule,
  getSinglePage,
};

export default sessions;
